// SPDX-FileCopyrightText: 2026 Z-Meet contributors
// SPDX-License-Identifier: Apache-2.0

import { useState } from 'react'
import { DoorOpen } from '@phosphor-icons/react'
import { useI18n } from '../i18n'

/**
 * Màn hình đầu tiên: một ô nhập mã.
 *
 * Không có gì khác ở đây, và đó là chủ đích. Người mở Z-Meet gần như luôn đang
 * đi tới một cuộc họp cụ thể mà ai đó vừa gửi mã cho họ — phần lớn là khách
 * không có tài khoản (ADR-0003 §1). Bắt họ đi qua một trang giới thiệu, hay tệ
 * hơn là một màn hình đăng nhập, là đặt rào chắn trước đúng việc họ cần làm.
 */
export function Home({ onJoined }: { onJoined: (code: string) => void }) {
  const { t } = useI18n()
  const [code, setCode] = useState('')

  const go = (e: React.FormEvent) => {
    e.preventDefault()
    const clean = code.replace(/\D/g, '')
    if (clean) onJoined(clean)
  }

  return (
    <main className="center">
      <form className="card" onSubmit={go}>
        <h1>{t('ui.join.heading')}</h1>
        <p className="sub">{t('ui.join.home_hint')}</p>

        <label htmlFor="code">{t('ui.join.code')}</label>
        <input
          id="code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          inputMode="numeric"
          autoComplete="off"
          placeholder="1234567890"
          autoFocus
        />

        <button className="wide" type="submit" disabled={!code.trim()}>
          <DoorOpen size={18} weight="light" />
          {t('ui.join.join')}
        </button>
      </form>
    </main>
  )
}
